import { realEventService } from "./event.service";
import type { IEventService } from "../types";

/**
 * Resolved event service.
 * Production: Java legacy API (ventas.ticketin.ec) — activo mientras AWS ALB no responde.
 * TODO: cambiar a mobileEventService cuando el ALB esté activo.
 */
export const eventService: IEventService = realEventService;
